<template>
  <div
      ref="Snow3d"
      id="Snow3d"
      class="position-relative"
      style="background-size: 100% 100%; background-repeat: no-repeat; background-position: center;"
      :style="{
         width: `${defaultWidth}px`,
         height: `${defaultHeight}px`,
         maxWidth: `${defaultWidth}px`,
         maxHeight: `${defaultHeight}px`,
         backgroundColor: `${backgroundColor}`,
         backgroundImage: `url(${imgUrl})`
      }"
  >
  </div>
</template>

<script setup>
import {onMounted, onBeforeUnmount, onBeforeMount, reactive, ref, watchEffect} from "vue";
import defaultValue from "@/utils/defaultValue"
import colorTool from "@/utils/colorTool";
import freeImg from "@/utils/freeImg";

const {defaultWidth, defaultHeight} = defaultValue()
const {changeToRgb} = colorTool()

const {freeImages} = freeImg()

const props = defineProps(['effectTheme', 'controlMode'])

let effectThemeData = reactive(props.effectTheme)
let backgroundColor = ref('rgb(0,0,0)')
let imgUrl = ref(null)
let imagePathType = ref('')
let backgroundImage = ref('')
let Snow3d = ref(null)
let animateSpeed = ref(15)
let high = ref(null)
let low = ref(null)

function createAnimate() {
  // id 'Snow3d' 請勿變動
  const animateScript = document.createElement('script');
  animateScript.type = 'text/javascript';
  animateScript.async = true;
  animateScript.src = require('@/assets/snow3d/snow3d');
  Snow3d.value = animateScript
  stopAnimate()
}

function stopAnimate() {
  window['SNOW3D'].stop()
}

function removeAnimate() {
  window['SNOW3D'].remove()
}

function startAnimateDefault() {
  window['SNOW3D'].defaultMode()
}
function startAnimateLow() {
  window['SNOW3D'].lowMode()
}

function startAnimateDouble() {
  window['SNOW3D'].doubleMode()
}

async function removeAnimateWrap () {
  let parent = document.getElementById('Snow3d');
  if (parent.firstChild) await parent.removeChild(parent.firstChild)
  Snow3d.value = null
}

async function handleAnimateSpeed (speed) {
  if (speed && speed > 25) startAnimateDouble()
  else if (speed && speed < 25) startAnimateLow()
  else startAnimateDefault()
}

function handleAnimateSpeedByTemperature (high, low, now) {
  let lowHeightRange = Math.ceil((high - low) / 5) // 將高低差 分為 10個單位, 1單位

  let range = Math.trunc((now - low) / lowHeightRange)
  // 調整速度
  if (range <= 0)  return  (1 * 10)
  else if (range >= 5) return (5 * 10)
  else return  (range * 10)
}

onMounted( () => {
  createAnimate()
  // 速度&&開始動畫
  handleAnimateSpeed(animateSpeed.value)
})

watchEffect(() => {
  const {
    BackgroundColor,
    BackgroundImage,
    Speed: rotateSpeed
  } = effectThemeData

  // 速度&&開始動畫
  animateSpeed.value = rotateSpeed

  // 背景色
  let bgColor = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgb(BackgroundColor) : 'rgb(0,0,0)'
  backgroundColor.value = bgColor

  // 背景色, 背景圖 需 重置動畫
  if (
      backgroundImage.value !== BackgroundImage
  ) {
    backgroundColor.value = bgColor
    imagePathType.value = ''
    backgroundImage.value = BackgroundImage
    if (backgroundImage.value !== '') {
      if (props.controlMode && props.controlMode.toString() === 'true') {
        const pathSplit = backgroundImage.value.split('.')
        imgUrl.value = freeImages[pathSplit[0]]
        imagePathType.value = pathSplit[1]
        console.log(imgUrl.value);
      } else {
        imgUrl.value = backgroundImage.value.split('#')[0]
        if (imgUrl.value.endsWith('.mp4')) imagePathType.value = 'mp4'
        else if (imgUrl.value.endsWith('.webm')) imagePathType.value = 'webm'
        else if (imgUrl.value.endsWith('.gif')) imagePathType.value = 'gif'
      }
    }
    if (backgroundImage.value === '') {
      imgUrl.value = ''
      imagePathType.value = ''
    }
  }
  // animateSpeed 可以動態更新
  // nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''

  if (Snow3d.value) handleAnimateSpeed(animateSpeed.value)

  // if (IsDynamicMode.toString() === 'false') {
  //   if (Snow3d.value) handleAnimateSpeed(animateSpeed.value)
  // }
  // else if (IsDynamicMode.toString() === 'true') {
  //   high.value = HighValue
  //   low.value = LowValue
  //   // 控制雪量
  //   animateSpeed.valu = handleAnimateSpeedByTemperature(high.value, low.value, nowTemperature.value)
  //   if (Snow3d.value) handleAnimateSpeed(animateSpeed.value)
  // }

})

onBeforeUnmount( () => {
  stopAnimate()
  removeAnimate()
  removeAnimateWrap ()
})
</script>
